import React, { useEffect, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import styles from "./SettingsWindow.module.css";
import StatusSidebar from "../components/SettingsWindow/StatusSidebar";
import Checklists from "../components/SettingsWindow/CheckLists";
import { getChecklists } from "../api/checklists";
import HiddenFields from "../components/SettingsWindow/HiddenFields";
import { useSettingsState } from "../state/settingsState";
import { Button, Typography, Divider, Card, Space, Menu, Dropdown, notification, Layout } from 'antd';
import { SyncOutlined, AppstoreOutlined, DownOutlined } from '@ant-design/icons';
const { Content } = Layout;

const { Title } = Typography;

const SettingsWindow = () => {
  const { 
    selectedPipeline,
    selectedStatus,
    fields,
    hiddenFields,
    checklists,
    pipelines,
    updateData,
    getFilteredStatuses,
    setSelectedPipeline,
    setSelectedStatus,
    setHiddenFields,
    setChecklists
  } = useSettingsState();

  const [current, setCurrent] = useState('');

  useEffect(() => {
    updateData();
  }, []);

  useEffect(() => {
    if (selectedStatus) {
      getChecklists(selectedStatus.amo_status_id)
        .then(data => setChecklists(data))
        .catch(() => {
          notification.error({
            message: 'Ошибка',
            description: 'Не удалось загрузить чеклисты',
            placement: 'bottomRight'
          });
        });
    }
  }, [selectedStatus, setChecklists]);

  return (
    <div className="widget-container">
      <Layout className={styles.container}>
        <StatusSidebar />
        <Content style={{ padding: '24px', background: '#f9f9f9' }}>
          {selectedStatus && (
            <Card title={selectedStatus.name}>
              <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <DndProvider backend={HTML5Backend}>
                  <Checklists
                    checklists={checklists}
                    setChecklists={setChecklists}
                    fields={fields}
                    selectedStatus={selectedStatus}
                  />
                </DndProvider>
              </Space>
            </Card>
          )}
        </Content>
      </Layout>
    </div>
  );
};

export default SettingsWindow;
